import { parse } from 'fecha'

/**
 * steamer-browserutils
 * github: https://github.com/SteamerTeam/steamer-browserutils
 * npm: https://www.npmjs.com/package/steamer-browserutils
 * version: 1.0.0
 * date: 2016.01.10
 */
/**
 * @common functions
 * @author heyli
 * @date 2016.07.30
 */

/**
 * modify to fix node env
 * @author abwang
 */

var global = require('global')

/**
 * stringify value
 * @param  {String} val [value]
 * @return {String}     [stringified value]
 */
export function _stringify(val) {
    var returnVal = isObject(val) ? JSON.stringify(val) : val
    return returnVal
}

/**
 * parse string
 * @param  {String} val [value]
 * @return {String}     [object value]
 */
export function _parse(val) {
    var returnVal = isObject(val) ? val : JSON.parse(val)
    return returnVal
}
/**
 * @class features
 * @author heyli
 * @date 2016.07.30
 */

/**
 * [extend object]
 * @param  {Object} src [src object]
 * @param  {Object} des [extended object]
 * @param  {Integer} d   [depth]
 */
export function extend(src, des, d) {
    var depth = d ? d : 0
    for (var key in src) {
        var isObjectVal = isObject(src[key])
        var isArrayVal = isArray(src[key])
        if (isObjectVal || isArrayVal) {
            if (depth) {
                if (isObjectVal) {
                    des[key] = {}
                    extend(src[key], des[key], depth - 1)
                } else if (isArrayVal) {
                    des[key] = []
                    extend(src[key], des[key], depth - 1)
                }
            }
        } else {
            des[key] = src[key]
        }
    }
}

/**
 * [extend object]
 * @param  {Object} target [extended object]
 * @param  {Object} src    [src object]
 */
export function assign(target /*, src1, src2, src3...*/) {
    // 这里不用 (!target)，是因为primitive value 也可以被包裹成 object，再进行assign，最后返回object
    if (target == null) {
        throw new TypeError('无法将 undefined 或 null 转化为 object 从而被assign')
    }
    target = Object(target)
    for (var index = 1; index < arguments.length; index++) {
        var source = arguments[index]
        // 这里不用 !source，是因为字符串也可以被进行assign，转成 {0: xx, 1: xxx ...}
        if (source != null) {
            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key]
                }
            }
        }
    }
    return target
}

/**
 * @description Browser cookie processing
 * @author heyli
 * @date 2016.07.30
 * 正则表达式网站  http://www.regexr.com/
 */

/**
 * set cookie
 * @param {String} key    [key]
 * @param {String} val    [value]
 * @param {String} days   [days]
 * @param {String} path   [path]
 * @param {String} domain [domain]
 */
export function setCookie(key, val, days, path, domain) {
    var expire = new Date()
    expire.setTime(expire.getTime() + (days ? 3600000 * 24 * days : 30 * 24 * 60 * 60 * 1000)) // 默认1个月
    document.cookie =
        key +
        '=' +
        encodeURIComponent(_stringify(val)) +
        ';expires=' +
        expire.toGMTString() +
        ';path=' +
        (path ? path : '/') +
        ';' +
        (domain ? 'domain=' + domain + ';' : '')
}

/**
 * del cookie
 * @param  {String} key    [key]
 * @param  {String} path   [path]
 * @param  {String} domain [domain]
 */
export function delCookie(key, path, domain) {
    var expires = new Date(0)
    document.cookie = key + '=;expires=' + expires.toUTCString() + ';path=' + (path ? path : '/') + ';' + (domain ? 'domain=' + domain + ';' : '')
}

/**
 * get cookie
 * @param  {[type]} key [key]
 * @return {String}     [cookie value]
 */
export function getCookie(key) {
    var r = new RegExp('(?:^|;+|\\s+)' + key + '=([^;]*)')
    var m = global.document ? global.document.cookie.match(r) : ''

    return (!m ? '' : m[1]) || null
}
/**
 * @date functions
 * @author heyli
 * @date 2016.07.30
 */

/**
 * 对Date的扩展，将 Date 转化为指定格式的String
 * 月(M)、日(d)、12小时(h)、24小时(H)、分(m)、秒(s)、周(E)、季度(q) 可以用 1-2 个占位符
 * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 * eg:
 * formatDate(new Date(),'yyyy-MM-dd') ==> 2014-03-02
 * formatDate(new Date(),'yyyy-MM-dd hh:mm') ==> 2014-03-02 05:04
 * formatDate(new Date(),'yyyy-MM-dd HH:mm') ==> 2014-03-02 17:04
 * formatDate(new Date(),'yyyy-MM-dd hh:mm:ss.S') ==> 2006-07-02 08:09:04.423
 * formatDate(new Date(),'yyyy-MM-dd E HH:mm:ss') ==> 2009-03-10 二 20:09:04
 * formatDate(new Date(),'yyyy-MM-dd EE hh:mm:ss') ==> 2009-03-10 周二 08:09:04
 * formatDate(new Date(),'yyyy-MM-dd EEE hh:mm:ss') ==> 2009-03-10 星期二 08:09:04
 * formatDate(new Date(),'yyyy-M-d h:m:s.S') ==> 2006-7-2 8:9:4.18
 * @param dt
 * @param fmt
 * @param isUTC      是否使用标准(绝对)时间，在某些情况下有用（比如提取某个时间的绝对小时数）。
 */
var formatDate = function(dt, fmt, isUTC = false) {
    if (typeof dt === 'undefined') {
        return
    }

    var date = isDate(dt) ? dt : new Date(dt)

    var locale = isUTC ? 'UTC' : ''

    var o = {
        'M+': date[`get${locale}Month`]() + 1, //月份
        'd+': date[`get${locale}Date`](), //日
        'h+': date[`get${locale}Hours`]() % 12 === 0 ? 12 : date.getHours() % 12, //小时
        'H+': date[`get${locale}Hours`](), //小时
        'm+': date[`get${locale}Minutes`](), //分
        's+': date[`get${locale}Seconds`](), //秒
        'q+': Math.floor((date[`get${locale}Month`]() + 3) / 3), //季度
        S: date[`get${locale}Milliseconds`]() //毫秒
    }

    var week = {
        '0': '\u65e5',
        '1': '\u4e00',
        '2': '\u4e8c',
        '3': '\u4e09',
        '4': '\u56db',
        '5': '\u4e94',
        '6': '\u516d'
    }

    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }

    if (/(E+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length > 1 ? (RegExp.$1.length > 2 ? '\u661f\u671f' : '\u5468') : '') + week[date.getDay() + ''])
    }

    for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
        }
    }

    return fmt
}

export { formatDate }
/**
 * @browser localstorage processing
 * @author heyli
 * @date 2016.07.30
 */

/**
 * set localstorage
 * @param {String} key [key]
 * @param {String} val [value]
 */
export function setItem(key, val) {
    val = _stringify(val)
    if (typeof window.Storage !== 'undefined') {
        localStorage.setItem(key, val)
    } else {
        setCookie(key, val)
    }
}

/**
 * get localstorage
 * @param  {String} key [key]
 * @return {String}     [value]
 */
export function getItem(key) {
    if (typeof window.Storage !== 'undefined') {
        return localStorage.getItem(key)
    } else {
        return getCookie(key)
    }
}

/**
 * delete localstorage
 * @param  {String} key [key]
 * @return {String}     [value]
 */
export function delItem(key) {
    if (typeof window.Storage !== 'undefined') {
        delete localStorage[key]
    } else {
        delCookie(key)
    }
}

/**
 * @browser safe functions
 * @author heyli
 * @date 2016.07.30
 */

/**
 * html实体编码
 * @param  {String} str html文本
 * @return {String}     经html实体编码后的html文本
 */
export function encodeHTML(str) {
    //&gt; 实体标签
    //&#34; Unicode 编码（可以用charCodeAt方法查看某字符对应的unicode编码）
    var s = ''
    if (!str || str.length == 0) return ''
    s = str.replace(/&/g, '&#38;')
    s = s.replace(/</g, '&lt;')
    s = s.replace(/>/g, '&gt;')
    s = s.replace(/'/g, '&#39;')
    s = s.replace(/"/g, '&quot;')
    //空格和换行其实可以不转
    s = s.replace(/ /g, '&nbsp;')
    s = s.replace(/\n/g, '<br>')
    return s
}

/**
 * html实体编码转义
 * @param  {String} str html文本
 * @return {String}     经html实体编码转义后的html文本
 */
export function decodeHTML(str) {
    var s = ''
    if (str.length == 0) return ''
    s = str.replace(/&#38;/g, '&')
    s = s.replace(/&lt;/g, '<')
    s = s.replace(/&gt;/g, '>')
    s = s.replace(/&#39;/g, "'")
    s = s.replace(/&quot;/g, '"')
    s = s.replace(/&nbsp;/g, ' ')
    s = s.replace(/<br>/g, '\n')
    return s
}
/**
 * @description JS Type Checking
 * @author heyli
 * @date 2016.07.30
 */

export function isType(type, obj) {
    return Object.prototype.toString.call(obj) === '[object ' + type + ']'
}

export function isBoolean(obj) {
    return isType('Boolean', obj)
}

export function isNumber(obj) {
    return isType('Number', obj)
}

export function isString(obj) {
    return isType('String', obj)
}

export function isFunction(obj) {
    return isType('Function', obj)
}

export function isArray(obj) {
    return isType('Array', obj)
}

export function isDate(obj) {
    return isType('Date', obj)
}

export function isRegExp(obj) {
    return isType('RegExp', obj)
}

export function isObject(obj) {
    return isType('Object', obj)
}

export function isError(obj) {
    return isType('Error', obj)
}

/**
 * @description JS url processing
 * @author heyli
 * @date 2016.07.30
 */

/**
 * get hash param
 * @param  {String} key [key]
 * @return {String}     [value]
 */
export function getHash(key) {
    var m = global.location ? global.location.hash.match(new RegExp('(#|&)' + key + '=([^&#]*)(#|&|$)')) : ''
    return !m ? '' : decodeURIComponent(m[2])
}

/**
 * get query param
 * @param  {String} key [key]
 * @return {String}     [value]
 */
export function getQuery(key) {
    var m = global.location ? global.location.search.match(new RegExp('(\\?|&)' + key + '=([^&]*)(#|&|$)')) : ''
    return !m ? '' : decodeURIComponent(m[2])
}

/**
 * get query or hash param
 * @param  {String} key [key]
 * @return {String}     [value]
 */
export function getUrlParam(key) {
    var m = global.location ? global.location.search.match(new RegExp('(\\?|#|&)' + key + '=([^&]*)(#|&|$)')) : ''

    if (!m) {
        m = global.location ? global.location.hash.match(new RegExp('(#|&)' + key + '=([^&#]*)(#|&|$)')) : ''
    }

    return !m ? '' : decodeURIComponent(m[2])
}

/**
 * 给url添加query
 * @param {String} url
 * @param {String} key
 * @param {String} value
 *
 * @return {String} url
 */
export function addQuery(url, key, value) {
    if (!key || (!value && value !== 0)) {
        return url
    }

    url += (~url.indexOf('?') ? '&' : '?') + `${key}=${value}`
    return url
}

/**
 * 由对象生成查询字符串 key=value&key2=value2
 * @param query
 * @returns {{}}
 */
export function createSearchParams(query = {}) {
    // 没有做query是object的强判断，传参请自觉
    query = Object.keys(query)
        .map(key => {
            return `${key}=${encodeURIComponent(query[key])}`
        })
        .join('&')

    return query
}

/* 检查response的合法性 */
export function verifyResponse(res) {
    var { msg, retcode, errCode } = res.data
    if (retcode === 0 || errCode === 0) {
        return res.data
    }

    if (retcode === 100000) {
        msg = '未登录，请登录后重试 ' + msg
    }

    var err = new Error(msg)
    err.retcode = retcode || errCode

    throw err
}

/* 获取字符串长度，默认中文占两个chLength */
export function getUnicodeLength(str, chLength = 2) {
    var length = 0
    var reg = /[\u4e00-\u9fa5]/
    for (var i = 0; i < str.length; i++) {
        if (reg.test(str.charAt(i))) {
            length += chLength
        } else {
            length++
        }
    }
    return length
}

// let ua = navigator && navigator.userAgent.toLowerCase()
// let _getPlatform = function(os) {
//     let ver = ('' + (new RegExp(os + '(\\d+((\\.|_)\\d+)*)').exec(ua) || [, 0])[1]).replace(/_/g, '.')
//     // undefined < 3 === false, but null < 3 === true
//     return parseFloat(ver) || undefined
// }

let os = (() => {
    let ua = typeof navigator !== 'undefined' && navigator && navigator.userAgent.toLowerCase()
    let _getPlatform = function(os) {
        let ver = ('' + (new RegExp(os + '(\\d+((\\.|_)\\d+)*)').exec(ua) || [, 0])[1]).replace(/_/g, '.')
        // undefined < 3 === false, but null < 3 === true
        return _parseVersion(ver, 3) || undefined
    }
    function _parseVersion(version, num) {
        // 没有拿到ua对应的值，这里version会传'0'，由于'0'的布尔值判断是true，会影响下面的platform判断，这里做个处理
        if (!version || version === '0') {
            return;
        }

        return version
            .split('.')
            .splice(0, num)
            .join('.')
    }
    return {
        ios: _getPlatform('os '),
        android: _getPlatform('android[/ ]'),
        pc: _getPlatform('hygroupvideopc[/ ]') || (!_getPlatform('os ') && !_getPlatform('android[/ ]'))
    }
})()

/**
 * 获取平台值
 * @return {String} ios | android | pc
 */
let platform = ''
export function getPlatform() {
    if (platform) {
        return platform
    }

    if (os.android) {
        return (platform = 'android')
    }
    if (os.ios) {
        return (platform = 'ios')
    }
    if (os.pc) {
        return (platform = 'pc')
    }
}

/* 函数节流 */
export function throttle(cb, time) {
    let obj = {}
    obj.handle = null

    return function() {
        var args = arguments
        time = time || 150
        clearTimeout(obj.handle)
        obj.handle = setTimeout(function() {
            cb.apply(this, args)
        }, time)
    }
}

export function calcBkn(str) {
    if (!str) return ''

    var hash = 5381
    for (var i = 0, len = str.length; i < len; ++i) {
        hash += (hash << 5) + str.charAt(i).charCodeAt()
    }
    return hash & 0x7fffffff
}

let _uin
export function getUin() {
    if (typeof _uin === 'undefined' || _uin === '') {
        _uin = getCookie('uin').replace(/^[o0]+/i, '')
    }
    return _uin
}

export function localStorageEmit(key, value) {
    localStorage.removeItem(key)
    localStorage.setItem(key, value || Math.random())
}

export function localStorageOn(key, callback) {
    window.addEventListener('storage', function(e) {
        if (e.key === key) {
            callback && callback(e)
            localStorage.removeItem(key)
        }
    })
}

/**
 * 保留小数指定的位数，不四舍五入
 * @param {Number} num 小数
 * @param {Number} digit 保留的位数
 * @return {String} 截取位数后的小数
 */
export function cutDecimalDigits(num, digit = 2) {
    let numStr = `${num}`,
        dotIndex = numStr.indexOf('.')

    if (dotIndex >= 0 && dotIndex < numStr.length - digit) {
        numStr = numStr.substring(0, numStr.indexOf('.') + digit + 1)

        return Number(numStr)
    }

    return num
}
/**
 * 防抖动器
 * @param  {Function} func      需执行的方法
 * @param  {number}   delay     延迟时间
 * @param  {boolean}  immediate 是否立即执行
 * @return {Function}           防抖动方法
 */
export function debounce(func, delay, immediate) {
    var timeout

    return function() {
        immediate = !!immediate

        var context = this,
            args = arguments,
            callNow = immediate && !timeout

        var delayFunc = function() {
            timeout = null
            if (!immediate) {
                func.apply(context, args)
            }
        }

        clearTimeout(timeout)
        timeout = setTimeout(delayFunc, delay || 100)

        if (callNow) {
            func.apply(context, args)
        }
    }
}
export const getViewportSize = (() => {
    let viewport = null
    return function() {
        if (!viewport) {
            viewport = {
                width: document.documentElement.clientWidth || document.body.clientWidth,
                height: document.documentElement.clientHeight || document.body.clientHeight
            }
            console.log(viewport)
        }
        return viewport
    }
})()
export function callApi(url) {
    var iframe = document.createElement('iframe')
    iframe.src = url
    iframe.height = 0
    iframe.width = 0
    iframe.style.cssText = 'display: none'

    document.body.appendChild(iframe)

    setTimeout(function() {
        document.body.removeChild(iframe)
        iframe = null
    }, 2000)
}
/**
 * 获取对象嵌套了多层的属性值，接口调用方式类似于immutable的getIn
 * @param {Object}      obj             对象
 * @param {Array}       keyArray        嵌套属性的数组，如想获取 obj.a.b.c,则为['a','b','c']
 * @return      对应的嵌套属性的值
 */
export function getIn(obj, keyArray = []) {
    if (typeof obj.getIn === 'function') {
        return obj.getIn(keyArray)
    }

    var current = obj

    for (var i = 0; i < keyArray.length; i++) {
        if (current[keyArray[i]] === undefined) {
            return undefined
        } else {
            current = current[keyArray[i]]
        }
    }

    return current
}

/**
 * 去重
 * @param {Array} array         对象数组
 * @param {String|Number} key   元素对象中的用于区分不同对象的键
 * @return {Array}  去重后的数组
 */
export function unique(array, key) {
    var res = [],
        keyArray = []
    for (var i = 0, len = array.length; i < len; i++) {
        var currentItem = array[i],
            currentKey = currentItem[key]
        if (keyArray.indexOf(currentKey) === -1) {
            keyArray.push(currentKey)
            res.push(currentItem)
        }
    }
    return res
}

/**
 * 产生url参数
 * @param {object} param
 */
export function generateParams(param) {
    let paramList = []

    for (let i in param) {
        paramList.push(i + '=' + encodeURIComponent(param[i]))
    }

    return paramList.join('&')
}
